import React, { memo } from 'react'

import { useTranslation } from 'react-i18next'
import HasPermissions from '../../../../../common-components/HasPermissions'

import CustomerPortal from '../../../../CustomerPortal'
import History from '../../../../History'
import AcknowledgeInboundShipmentsReminderPopup from '../../../../AcknowledgeInboundShipmentsReminderPopup'

import {
  FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_ACKNOWLEDGE_INBOUND_SHIPMENTS,
} from '../../../../../constants/permissions'

import {
  CUSTOMER_TYPES_BREWER,
} from '../../../../../constants'


export default memo(({ // Why memo? See CODE_COMMENTS_253
  customerId,
  hasNonExpiredNonConbrwPpfContract,
}) => {
  const { t: translate } = useTranslation('common')
  return (
    <div>
      <CustomerPortal
        customerId={customerId}
        customerType={CUSTOMER_TYPES_BREWER}
      />
      <History customerId={customerId} translate={translate} />
      {
        hasNonExpiredNonConbrwPpfContract && (
          <HasPermissions
            requiredPermissions={FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_ACKNOWLEDGE_INBOUND_SHIPMENTS}
            renderIfHasPermissions={
              () => <AcknowledgeInboundShipmentsReminderPopup customerId={customerId} />
            }
          />
        )
      }
    </div>
  )
})
